import { priceDisplayFormat } from "aldoo-ra/CMSModels/StorePrice/display-formatters"
import { url } from "aldoo-ra/CMS/url"
import Typography from "aldoo-ra/Typography"

/**
 * This is how we render a product in the Shopping Cart
 */
export default function Product({ product }) {
  return (
    <div className="relative flex items-start md:items-center justify-start bg-primary/5 rounded-[10px] gap-5 p-5 overflow-hidden">
      <div className="w-20 h-20 rounded-[5px] overflow-hidden shadow-lg shrink-0">
        <img
          className="w-full h-full object-cover shrink-0"
          src={url(product.thumbnail)}
          alt={product.name}
        />
      </div>

      <div className="w-full flex flex-col md:flex-row items-start md:items-center gap-1 md:gap-2">
        <div className="flex flex-col">
          <Typography variant="body1_accent" className="text-text">
            {product.name}
          </Typography>
          {product.description && (
            <Typography variant="txt_dim" className="mt-0.5">
              {product.description}
            </Typography>
          )}
        </div>

        <Typography variant="body1_accent" className="text-text my-0 md:ml-auto">
          {priceDisplayFormat(product.amount, product.currency)}
        </Typography>
      </div>
    </div>
  )
}
